const features = [
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '全站剧集支持高清分辨率播放，画质细腻不模糊，给您影院级观感体验。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅不缓冲',
    desc: '采用先进的视频加速技术，播放流畅零卡顿，追剧过程一气呵成。',
  },
  {
    icon: 'ri-global-line',
    title: '海量剧库',
    desc: '国产剧全集、韩剧全集一站收录，每日更新最新电视剧，片源丰富不剧荒。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '完美适配电脑、平板与手机，随时随地打开浏览器即可免费在线观看。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    desc: '纯净观影环境，无弹窗无恶意跳转，为您打造安心舒适的追剧空间。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          平台优势
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          为什么选择老子影视网免费观看电视剧
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-6 text-center group cursor-pointer hover:bg-white transition-colors duration-200"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-accent-100 flex items-center justify-center">
                <i className={`${item.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}